module.exports = __webpack_public_path__ + "192a30489c692f6961dbc9a0e488b99e.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/manage-group/settings/group-settings.html
// module id = 2081
// module chunks = 0